export const isLocalhost = () => {
  const { hostname } = window.location;

  return (
    hostname === 'localhost'
    || hostname === '' // if used via iframe
    || hostname === 'docker'
    || hostname === '127.0.0.1'
    || hostname === '[::1]'
    || hostname.startsWith('192.168')
    || hostname.startsWith('10.'));
};

// Known domains that mean "production"
const KNOWN_PROD_MATCHERS = ['micro-frontend-coms.telefonica.de', 'micro-frontend-proxy.high.coms-prod.aws.de.pri.o2.com', 'micro-frontend-coms'];

const LOCALHOST_ENVIRONMENT = 'development';

/**
 * Returns the COMS environment name (main, ict, ...) for a given microfrontend integrations.
 */
export const getMicrofrontendEnvironmentName = () => {
  if (isLocalhost()) {
    return LOCALHOST_ENVIRONMENT;
  }

  let microfrontendScriptHostname = window.location.hostname;
  const microfrontendScriptTags = document.querySelectorAll("script[src*='tef-coms']") as NodeListOf<HTMLScriptElement>; // eslint-disable-line -- Do not remove my NodeListOf<> eslint!
  if (microfrontendScriptTags.length > 0) {
    // Assuming that every script tag uses the same source FQDN
    microfrontendScriptHostname = new URL(microfrontendScriptTags[0].src).host;
  }

  // Hosted on micro-frontend proxy?
  const { environment } = /^(?<environment>.*?)-micro-frontend-proxy/.exec(microfrontendScriptHostname)?.groups ?? {};
  if (environment) {
    return environment;
  }

  // Known production URL?
  if (KNOWN_PROD_MATCHERS.some((knownProdMatcher) => microfrontendScriptHostname.includes(knownProdMatcher))) {
    return 'prod';
  }

  return 'unknown';
};

export const getMicrofrontendClusterName = (environment: string) => {
  if (environment === LOCALHOST_ENVIRONMENT) {
    return undefined;
  }
  return ['prod', 'pre-prod', 'ort', 'dry'].includes(environment) ? 'prod' : 'dev';
};
